module.exports = __webpack_public_path__ + "static/media/pool-dark.e7394035.svg";